<template>
  <div class="forgot-page">
    <div class="overlay"></div>
    <div class="forgot-form justify-content-center no-gutters" :class="step">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { ENV_IS_PRODUCTION } from '@/util/constants'

export default {
  computed: {
    step () {
      return this.$route.name.split('.')
    }
  },
  methods: {

  },
  mounted () {
    let name = this.$route.name
    var routesArr = [
      'Forgot.Step1.en',
      'Forgot.Step2.en',
      'Forgot.Step3.en',
      'Forgot.Step1.fi',
      'Forgot.Step2.fi',
      'Forgot.Step3.fi'
    ]
    var isChildPage = (routesArr.indexOf(name) > -1) || false
    if (!isChildPage) {
      this.$router.push({name: `Home.${this.$i18n.i18next.language}`})
    }
  }
}
</script>

<style lang="scss" scoped>
  .forgot-page {
    position: relative;
    background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/header_placeholder.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: auto;
    z-index: 3;

    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      z-index: -1;
    }

    .forgot-form {
      margin: 3rem auto;
      padding: 15px;
      max-width: 500px;
      background: white;
    }
  }

  .lang-switcher {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.5rem;
  }
  .company-description {
    margin: 1.5rem 0;
    text-align: center;
  }
</style>
